import { render, staticRenderFns } from "./treeindex.vue?vue&type=template&id=450d0258&scoped=true&"
import script from "./treeindex.vue?vue&type=script&lang=js&"
export * from "./treeindex.vue?vue&type=script&lang=js&"
import style0 from "./treeindex.vue?vue&type=style&index=0&id=450d0258&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450d0258",
  null
  
)

export default component.exports